import { ObjectField } from "components/Form/ObjectField"

export const PriceField = (props) => {
  props.schema.properties.currency.options.widget = "currency"

  return <ObjectField {...props} />
}
